module.exports = __webpack_public_path__ + "static/cla-persona-b253b5a33da3b9dd6e56589f8147c22a.png";